import {
	FETCH_PROGRAM_INFO,
	FETCH_PROGRAM_CATS,
	FETCH_INDIVIDUAL_PROGRAM_WORKOUTS,
	FETCH_WORKOUT_CATS,
	FETCH_PROGRAMS,
	RESET_PROGRAMS,
	FETCH_STORE_PRODUCTS,
	UPDATE_ORDER_PROGRAMS
} from '../actionTypes';
import axios from 'axios';
import { showAlert } from './alert';
import { showLoader, hideLoader } from './loader';
import { checkState } from './../../helpers'

const SERVICE = 'programs';

export const fetchInfo = programId => (dispatch, getState) => {
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	let promises = [];
	const state = getState();
	const { programCats } = state;
	promises = checkState(promises, 'categories',  {
		type: 'program'
	}, programCats)
	promises.push(
		axios.get(`programs/${programId}`, {
			params: {
				_embed: 'days',
			},
		})
	);
	return new Promise((respond, rej) => {
		Promise.all(promises).then(values => {
			const programCats = values[0].data;
			const programData = values[1].data;
			const workoutIds = programData['days'].map(day => {
				return day.workoutId ? day.workoutId : null;
			});
			axios
				.get('workouts', {
					params: {
						workoutIds: workoutIds,
					},
				})
				.then(res => {
					dispatch({
						type: FETCH_INDIVIDUAL_PROGRAM_WORKOUTS,
						payload: res.data,
					});
					dispatch({
						type: FETCH_PROGRAM_CATS,
						payload: programCats,
					});
					dispatch({
						type: FETCH_PROGRAM_INFO,
						payload: {
							[programId]: programData,
						},
					});
					dispatch(hideLoader());
					respond();
				});
		});
	});
};

export const createProgram = (parentData, weeks) => dispatch => {
	dispatch(showLoader());
	return new Promise((responseCreate, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		// parentData.name = parentData.name.toUpperCase();
		axios
			.post(SERVICE, parentData)
			.then(res => {
				const program = res.data;
				var promises = [];
				//make circuits first
				for (let week in weeks) {
					let days = weeks[week];
					for (var day in days) {
						if (!days[day].workoutId && !days[day].type) continue;
						promises.push(
							axios.post('programs/days', {
								...days[day],
								programId: program._id,
								day: parseInt(day, 0),
								week: parseInt(week, 0),
								month: Math.floor((week - 1) / 4) + 1,
							})
						);
					}
				}

				Promise.all(promises)
					.then(day => {
						dispatch(hideLoader());
						dispatch(showAlert(`Program updated successfully.`));
						responseCreate(program);
					})
					.catch(function (error) {
						dispatch(hideLoader());
						console.warn(error);
					});
			})
			.catch(function (error) {
				handleError(dispatch, error)
			});
	});
};

export const updateOrder  = (items) => dispatch => {
	dispatch(showLoader());
	dispatch({
		type: UPDATE_ORDER_PROGRAMS,
		payload: items,
	});
	return new Promise(async (response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.patch(`${SERVICE}/update/byOrders`, { orders: items })
			.then(res => {
				dispatch(hideLoader());
			})
			.catch(err => {
				dispatch(hideLoader());
				return dispatch(showAlert(err.message));
			});
	});
};

export const patchProgram = (parentData, weeks, deletedWeek) => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		// parentData.name = parentData.name
		// .toLowerCase()
		// .split(' ')
		// .map(s => s.charAt(0).toUpperCase() + s.substring(1))
		// .join(' ');
		axios
			.patch(`${SERVICE}/${parentData.id}`, parentData)
			.then(res => {
				const program = res.data;
				var promises = [];
				//make circuits first
				for (let week in weeks) {
					let days = weeks[week];
					for (var day in days) {
						if (!days[day].workoutId && !days[day].type) continue;
						if (days[day]._id) {
							promises.push(
								axios.patch(`programs/days/${days[day]._id}`, {
									...days[day],
									day: parseInt(day, 0),
									week: parseInt(week, 0),
									month: Math.floor((week - 1) / 4) + 1,
								})
							);
						} else {
							promises.push(
								axios.post('programs/days', {
									...days[day],
									programId: program._id,
									day: parseInt(day, 0),
									week: parseInt(week, 0),
									month: Math.floor((week - 1) / 4) + 1,
								})
							);
						}
					}
				}
				if (deletedWeek) {
					Object.values(deletedWeek).forEach(day => {
						if (day._id) {
							promises.push(axios.delete(`programs/days/${day._id}`));
						}
					});
				}

				Promise.all(promises)
					.then(() => {
						dispatch(hideLoader());
						dispatch(showAlert(`Program updated successfully.`));
						response(program);
					})
					.catch(function (error) {
						dispatch(hideLoader());
						console.warn(error);
					});
			})
			.catch(error => {
				dispatch(hideLoader());
				console.warn(error);
				error.message && dispatch(showAlert(error.message, true));
			});
	});
};

export const duplicateProgram = programId => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.post(`${SERVICE}/duplicate/${programId}`, {})
			.then(res => {
				dispatch(hideLoader());
				dispatch(showAlert(res.data.message));
				response(res.data);
			})
			.catch(error => {
				dispatch(hideLoader());
				console.warn(error);
				error.message && dispatch(showAlert(error.message, true));
				reject();
			});
	});
};

export const archiveProgram = (data) => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.post(`${SERVICE}/archive/${data._id}`, {status: data.status})
			.then(res => {
				dispatch(hideLoader());
				dispatch(showAlert(res.data.message));
				response(res.data);
			})
			.catch(error => {
				dispatch(hideLoader());
				console.warn(error);
				error.message && dispatch(showAlert(error.message, true));
				reject();
			});
	});
};

export const fetchFormValues = (userId, editId) => (dispatch, getState) => {
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	const state = getState();
	const { programCats, workoutCats, products } = state;
	let promises = [];
	promises = checkState(promises, 'categories',  {
		type: 'program',
	}, programCats)
	promises = checkState(promises, 'categories',  {
		type: 'workout'
	}, workoutCats)
	promises = checkState(promises, 'products',  {}, products);
	if (editId) {
		promises.push(dispatch(fetchInfo(editId)));
	}
	return new Promise((respond, rej) => {
		Promise.all(promises).then(values => {
			const programCats = values[0].data;
			const workoutCats = values[1].data;
			const storeProducts = values[2].data;
			dispatch({
				type: FETCH_PROGRAM_CATS,
				payload: programCats,
			});
			dispatch({
				type: FETCH_WORKOUT_CATS,
				payload: workoutCats,
			});
			dispatch({
				type: FETCH_STORE_PRODUCTS,
				payload: storeProducts,
			});
			dispatch(hideLoader());
			respond();
		});
	});
};
export const fetchList = query => dispatch => {
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	const promises = [];
	promises.push(axios.get('categories', { params: { type: 'program' } }));
	promises.push(
		axios.get(`programs`, {
			params: query,
		})
	);
	return new Promise((respond, rej) => {
		Promise.all(promises).then(values => {
			const workoutCats = values[0].data;
			const trainerPrograms = values[1].data;
			dispatch({
				type: FETCH_PROGRAM_CATS,
				payload: workoutCats,
			});
			dispatch({
				type: FETCH_PROGRAMS,
				payload: trainerPrograms,
			});
			dispatch(hideLoader());
			respond();
		});
	});
};

export const resetPrograms = () => dispatch => {
	dispatch({
		type: RESET_PROGRAMS,
	});
};

export const fetchMorePrograms = (query) => dispatch => {
	const promises = [];
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	promises.push(
		axios.get('programs', {
			params: query,
		})
	);
	if (query.skip === 0) {
		dispatch(showLoader());
	}
	return new Promise((respond, rej) => {
		Promise.all(promises).then(values => {
			const data = values[0].data;
			dispatch(hideLoader());
			dispatch({
				type: FETCH_PROGRAMS,
				payload: data,
			});
		});
	});
};

function handleError(dispatch, err) {
	dispatch(hideLoader());
	err.message && dispatch(showAlert(err.message, true));
}



// WEBPACK FOOTER //
// ./src/store/actions/programs.js